// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminDashboard_page__bBsHw { max-width: 1600px; }
.AdminDashboard_loading__c7kz6 { padding: 2rem; color: var(--gray-500); font-size: 0.85rem; }

.AdminDashboard_pageHeader__kUf8A {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.AdminDashboard_pageTitle__1wNpT { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; }
.AdminDashboard_pageSub__\\+X7l4 { font-size: 0.8rem; color: var(--gray-500); }

.AdminDashboard_headerActions__jXD8v {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.AdminDashboard_actionBtn__IpcR6 {
  padding: 0.55rem 1rem;
  background: var(--green);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.82rem;
  font-weight: 500;
  white-space: nowrap;
  transition: background 0.15s;
}
.AdminDashboard_actionBtn__IpcR6:hover { background: #155a30; }

.AdminDashboard_timePeriodSelect__P-IxV {
  padding: 0.55rem 1rem;
  background: white;
  color: var(--gray-700);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.AdminDashboard_timePeriodSelect__P-IxV:hover {
  border-color: var(--green);
}
.AdminDashboard_timePeriodSelect__P-IxV:focus {
  outline: none;
  border-color: var(--green);
  box-shadow: 0 0 0 2px rgba(26, 92, 56, 0.1);
}

.AdminDashboard_statsGrid__cavqM {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.85rem;
  margin-bottom: 1.75rem;
}

.AdminDashboard_statCard__tS-sS {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1rem 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.AdminDashboard_statValue__rZ5CS { font-size: 1.6rem; font-weight: 600; color: var(--gray-900); line-height: 1; }
.AdminDashboard_statLabel__My1GT { font-size: 0.78rem; font-weight: 500; color: var(--gray-700); margin-top: 4px; }
.AdminDashboard_statSub__PRdtu { font-size: 0.7rem; color: var(--gray-500); }

.AdminDashboard_section__rcszr {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.AdminDashboard_sectionHeader__6IgCz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid var(--border);
}

.AdminDashboard_sectionTitle__zarjn { font-size: 0.9rem; font-weight: 600; color: var(--gray-900); font-family: 'DM Sans', sans-serif; }

.AdminDashboard_linkBtn__uSzYi {
  background: none;
  border: none;
  color: var(--green);
  font-size: 0.78rem;
  font-weight: 500;
}
.AdminDashboard_linkBtn__uSzYi:hover { text-decoration: underline; }

.AdminDashboard_empty__oUATu {
  padding: 2.5rem 1.5rem;
  text-align: center;
  color: var(--gray-500);
  font-size: 0.82rem;
}

.AdminDashboard_tableWrap__xUaGM { overflow-x: auto; }

.AdminDashboard_table__-dmbJ {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.AdminDashboard_table__-dmbJ th {
  padding: 0.6rem 1rem;
  text-align: left;
  font-size: 0.72rem;
  font-weight: 500;
  color: var(--gray-500);
  text-transform: capitalize;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

.AdminDashboard_table__-dmbJ td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--gray-50);
  vertical-align: middle;
}

.AdminDashboard_table__-dmbJ tr:last-child td { border-bottom: none; }
.AdminDashboard_table__-dmbJ tr:hover td { background: var(--gray-50); }

.AdminDashboard_candidateCell__qbV4Y { display: flex; align-items: center; gap: 0.6rem; }
.AdminDashboard_candidateAvatar__xYTff {
  width: 28px; height: 28px;
  border-radius: 50%;
  background: var(--green-light);
  color: var(--green);
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 600; flex-shrink: 0;
}
.AdminDashboard_candidateName__TxN5g { font-weight: 500; color: var(--gray-900); line-height: 1.2; }
.AdminDashboard_candidateEmail__BaHOn { font-size: 0.72rem; color: var(--gray-500); }

.AdminDashboard_roleTag__I5lBJ {
  display: inline-block;
  padding: 2px 8px;
  background: var(--gray-100);
  border-radius: 100px;
  font-size: 0.72rem;
  font-weight: 500;
  color: var(--gray-700);
}

.AdminDashboard_muted__\\+lLaX { color: var(--gray-500); }
.AdminDashboard_pct__pYOzf { font-size: 0.75rem; color: var(--gray-500); }

.AdminDashboard_recoTag__QdbH8 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 100px;
  font-size: 0.72rem;
  font-weight: 500;
}
.AdminDashboard_tagGreen__W5N2X { background: var(--green-light); color: var(--green); }
.AdminDashboard_tagOrange__E7Ar5 { background: #fef3e2; color: #d35400; }
.AdminDashboard_tagRed__12Hu1 { background: var(--red-light); color: var(--red); }

.AdminDashboard_viewBtn__Z-hzj {
  padding: 4px 10px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.75rem;
  color: var(--gray-700);
  transition: all 0.12s;
}
.AdminDashboard_viewBtn__Z-hzj:hover { background: var(--green-light); color: var(--green); border-color: transparent; }

/* AI Dashboard Styles */
.AdminDashboard_aiSummary__zAfe6 {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: var(--radius-lg);
  padding: 1.25rem;
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  align-items: flex-start;
}

.AdminDashboard_aiIcon__fR\\+5A {
  font-size: 1.8rem;
  flex-shrink: 0;
}

.AdminDashboard_aiLabel__7pCgD {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  color: #0369a1;
  letter-spacing: 0.05em;
  margin-bottom: 0.3rem;
}

.AdminDashboard_aiText__HyJWc {
  font-size: 0.85rem;
  color: var(--gray-700);
  line-height: 1.5;
}

.AdminDashboard_aiLoadingText__WIjhh {
  font-size: 0.85rem;
  color: #0369a1;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 500;
}

.AdminDashboard_loadingSpinner__zY7SO {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(3, 105, 161, 0.3);
  border-top-color: #0369a1;
  border-radius: 50%;
  animation: AdminDashboard_spin__RuDpr 0.8s linear infinite;
}

@keyframes AdminDashboard_spin__RuDpr {
  to { transform: rotate(360deg); }
}

/* Metrics Grid */
.AdminDashboard_metricsGrid__pv7jV {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem;
}

.AdminDashboard_metricCard__zUJ1A {
  background: linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.AdminDashboard_metricValue__G216C {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--green);
  line-height: 1;
}

.AdminDashboard_metricLabel__e8kS3 {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--gray-700);
}

.AdminDashboard_metricInsight__dirTS {
  font-size: 0.75rem;
  color: var(--gray-600);
  line-height: 1.4;
}

/* Charts Grid */
.AdminDashboard_chartsGrid__eCTdn {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem;
}

.AdminDashboard_chartContainer__Ru1CU {
  background: var(--white);
}

.AdminDashboard_chartLabel__hBZiR {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 1rem;
}

.AdminDashboard_emptyChart__tOr2a {
  padding: 2rem;
  text-align: center;
  color: var(--gray-500);
  font-size: 0.85rem;
  background: var(--gray-50);
  border-radius: var(--radius);
}

/* Bar Chart */
.AdminDashboard_barChart__DuQ6r {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.AdminDashboard_barGroup__fqfDA {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.AdminDashboard_barLabel__kzZ\\+f {
  font-size: 0.75rem;
  color: var(--gray-600);
  min-width: 80px;
  font-weight: 500;
}

.AdminDashboard_barTrack__720ok {
  flex: 1 1;
  height: 24px;
  background: var(--gray-100);
  border-radius: 4px;
  overflow: hidden;
  min-width: 150px;
}

.AdminDashboard_bar__lYxOm {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 4px;
}

.AdminDashboard_barValue__7AYGS {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--gray-900);
  min-width: 30px;
  text-align: right;
}

/* Role Chart */
.AdminDashboard_roleChart__px7C- {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.AdminDashboard_roleItem__xZg66 {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.AdminDashboard_roleHeader__ocaLC {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.AdminDashboard_roleLabel__oV\\+FN {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--gray-700);
}

.AdminDashboard_roleCount__BW9S8 {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--gray-900);
}

.AdminDashboard_roleBar__1Xtcp {
  height: 20px;
  background: var(--gray-100);
  border-radius: 3px;
  overflow: hidden;
}

.AdminDashboard_roleFill__0llfF {
  height: 100%;
  transition: width 0.3s ease;
}

.AdminDashboard_rolePct__tzEu2 {
  font-size: 0.75rem;
  color: var(--gray-600);
  font-weight: 500;
}

/* Alerts */
.AdminDashboard_alertsList__pNumg {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.AdminDashboard_alert__5tZks {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border-radius: var(--radius);
  border-left: 4px solid;
  align-items: flex-start;
  font-size: 0.85rem;
  line-height: 1.4;
}

.AdminDashboard_alertpositive__b8t0r {
  background: #f0fdf4;
  border-color: #22c55e;
  color: #15803d;
}

.AdminDashboard_alertwarning__E-4he {
  background: #fefce8;
  border-color: #eab308;
  color: #854d0e;
}

.AdminDashboard_alertinfo__JWl5b {
  background: #f0f9ff;
  border-color: #0ea5e9;
  color: #0369a1;
}

.AdminDashboard_alertIcon__cWz98 {
  flex-shrink: 0;
  font-size: 1rem;
  font-weight: 600;
}

.AdminDashboard_alertMessage__JM5uz {
  flex: 1 1;
}

/* Insights & Recommendations */
.AdminDashboard_insightBox__pOpB- {
  padding: 1.5rem;
  background: var(--gray-50);
  border-radius: var(--radius);
  border-left: 4px solid var(--green);
  line-height: 1.6;
  color: var(--gray-700);
  font-size: 0.85rem;
}

.AdminDashboard_recommendationsList__Gvqns {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.AdminDashboard_recommendationItem__fHn4I {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: var(--gray-50);
  border-radius: var(--radius);
  border-left: 4px solid var(--green);
  align-items: flex-start;
  font-size: 0.85rem;
  line-height: 1.5;
}

.AdminDashboard_recNum__px7gt {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--green);
  color: white;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

.AdminDashboard_recText__9vut8 {
  flex: 1 1;
  color: var(--gray-700);
}

/* Skeleton Loaders */
@keyframes AdminDashboard_shimmer__dfFL1 {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}

.AdminDashboard_skeletonCard__c6rOu {
  padding: 1.5rem;
  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);
  background-size: 1000px 100%;
  animation: AdminDashboard_shimmer__dfFL1 2s infinite;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  height: 100px;
}

.AdminDashboard_skeletonText__7VKIE {
  height: 16px;
  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);
  background-size: 1000px 100%;
  animation: AdminDashboard_shimmer__dfFL1 2s infinite;
  border-radius: 4px;
}

.AdminDashboard_skeletonBar__sQllP {
  height: 40px;
  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);
  background-size: 1000px 100%;
  animation: AdminDashboard_shimmer__dfFL1 2s infinite;
  border-radius: 4px;
}

.AdminDashboard_skeletonMetricCard__des4H {
  padding: 1.5rem;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.AdminDashboard_skeletonAiSummary__tIMKS {
  height: 100px;
  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);
  background-size: 1000px 100%;
  animation: AdminDashboard_shimmer__dfFL1 2s infinite;
  border-radius: var(--radius);
  border-left: 4px solid var(--green);
  margin-bottom: 1.5rem;
}

@media (max-width: 900px) {
  .AdminDashboard_statsGrid__cavqM { grid-template-columns: repeat(3, 1fr); }
  .AdminDashboard_chartsGrid__eCTdn { grid-template-columns: 1fr; }
}
@media (max-width: 600px) {
  .AdminDashboard_statsGrid__cavqM { grid-template-columns: repeat(2, 1fr); }
  .AdminDashboard_metricsGrid__pv7jV { grid-template-columns: 1fr; }
  .AdminDashboard_chartsGrid__eCTdn { grid-template-columns: 1fr; }
  .AdminDashboard_aiSummary__zAfe6 { flex-direction: column; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminDashboard.module.css"],"names":[],"mappings":"AAAA,8BAAQ,iBAAiB,EAAE;AAC3B,iCAAW,aAAa,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;;AAEtE;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA,mCAAa,iBAAiB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC5E,kCAAW,iBAAiB,EAAE,sBAAsB,EAAE;;AAEtD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,yCAAmB,mBAAmB,EAAE;;AAExC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,mCAAa,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AAC1F,mCAAa,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC5F,iCAAW,iBAAiB,EAAE,sBAAsB,EAAE;;AAEtD;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,sCAAgB,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE;;AAEjH;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,uCAAiB,0BAA0B,EAAE;;AAE7C;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mCAAa,gBAAgB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,gDAA0B,mBAAmB,EAAE;AAC/C,2CAAqB,0BAA0B,EAAE;;AAEjD,uCAAiB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAClE;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;AACtD;AACA,uCAAiB,gBAAgB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC7E,wCAAkB,kBAAkB,EAAE,sBAAsB,EAAE;;AAE9D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAS,sBAAsB,EAAE;AACjC,6BAAO,kBAAkB,EAAE,sBAAsB,EAAE;;AAEnD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,kCAAY,8BAA8B,EAAE,mBAAmB,EAAE;AACjE,mCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,gCAAU,4BAA4B,EAAE,iBAAiB,EAAE;;AAE3D;EACE,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;AACA,uCAAiB,8BAA8B,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;;AAEjG,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,0DAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,KAAK,8BAA8B,EAAE;EACrC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,eAAe;EACf,+FAA+F;EAC/F,4BAA4B;EAC5B,oDAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+FAA+F;EAC/F,4BAA4B;EAC5B,oDAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,+FAA+F;EAC/F,4BAA4B;EAC5B,oDAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,+FAA+F;EAC/F,4BAA4B;EAC5B,oDAA8B;EAC9B,4BAA4B;EAC5B,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,mCAAa,qCAAqC,EAAE;EACpD,oCAAc,0BAA0B,EAAE;AAC5C;AACA;EACE,mCAAa,qCAAqC,EAAE;EACpD,qCAAe,0BAA0B,EAAE;EAC3C,oCAAc,0BAA0B,EAAE;EAC1C,mCAAa,sBAAsB,EAAE;AACvC","sourcesContent":[".page { max-width: 1600px; }\n.loading { padding: 2rem; color: var(--gray-500); font-size: 0.85rem; }\n\n.pageHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.pageTitle { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; }\n.pageSub { font-size: 0.8rem; color: var(--gray-500); }\n\n.headerActions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.actionBtn {\n  padding: 0.55rem 1rem;\n  background: var(--green);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.82rem;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n.actionBtn:hover { background: #155a30; }\n\n.timePeriodSelect {\n  padding: 0.55rem 1rem;\n  background: white;\n  color: var(--gray-700);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.timePeriodSelect:hover {\n  border-color: var(--green);\n}\n.timePeriodSelect:focus {\n  outline: none;\n  border-color: var(--green);\n  box-shadow: 0 0 0 2px rgba(26, 92, 56, 0.1);\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.85rem;\n  margin-bottom: 1.75rem;\n}\n\n.statCard {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1rem 1.1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.statValue { font-size: 1.6rem; font-weight: 600; color: var(--gray-900); line-height: 1; }\n.statLabel { font-size: 0.78rem; font-weight: 500; color: var(--gray-700); margin-top: 4px; }\n.statSub { font-size: 0.7rem; color: var(--gray-500); }\n\n.section {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.9rem 1.1rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.sectionTitle { font-size: 0.9rem; font-weight: 600; color: var(--gray-900); font-family: 'DM Sans', sans-serif; }\n\n.linkBtn {\n  background: none;\n  border: none;\n  color: var(--green);\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n.linkBtn:hover { text-decoration: underline; }\n\n.empty {\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  color: var(--gray-500);\n  font-size: 0.82rem;\n}\n\n.tableWrap { overflow-x: auto; }\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.table th {\n  padding: 0.6rem 1rem;\n  text-align: left;\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: var(--gray-500);\n  text-transform: capitalize;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n\n.table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--gray-50);\n  vertical-align: middle;\n}\n\n.table tr:last-child td { border-bottom: none; }\n.table tr:hover td { background: var(--gray-50); }\n\n.candidateCell { display: flex; align-items: center; gap: 0.6rem; }\n.candidateAvatar {\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  background: var(--green-light);\n  color: var(--green);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.75rem; font-weight: 600; flex-shrink: 0;\n}\n.candidateName { font-weight: 500; color: var(--gray-900); line-height: 1.2; }\n.candidateEmail { font-size: 0.72rem; color: var(--gray-500); }\n\n.roleTag {\n  display: inline-block;\n  padding: 2px 8px;\n  background: var(--gray-100);\n  border-radius: 100px;\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: var(--gray-700);\n}\n\n.muted { color: var(--gray-500); }\n.pct { font-size: 0.75rem; color: var(--gray-500); }\n\n.recoTag {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 100px;\n  font-size: 0.72rem;\n  font-weight: 500;\n}\n.tagGreen { background: var(--green-light); color: var(--green); }\n.tagOrange { background: #fef3e2; color: #d35400; }\n.tagRed { background: var(--red-light); color: var(--red); }\n\n.viewBtn {\n  padding: 4px 10px;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  color: var(--gray-700);\n  transition: all 0.12s;\n}\n.viewBtn:hover { background: var(--green-light); color: var(--green); border-color: transparent; }\n\n/* AI Dashboard Styles */\n.aiSummary {\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border: 1px solid #bae6fd;\n  border-radius: var(--radius-lg);\n  padding: 1.25rem;\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  align-items: flex-start;\n}\n\n.aiIcon {\n  font-size: 1.8rem;\n  flex-shrink: 0;\n}\n\n.aiLabel {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  color: #0369a1;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.3rem;\n}\n\n.aiText {\n  font-size: 0.85rem;\n  color: var(--gray-700);\n  line-height: 1.5;\n}\n\n.aiLoadingText {\n  font-size: 0.85rem;\n  color: #0369a1;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-weight: 500;\n}\n\n.loadingSpinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(3, 105, 161, 0.3);\n  border-top-color: #0369a1;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Metrics Grid */\n.metricsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.metricCard {\n  background: linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 1.2rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.metricValue {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--green);\n  line-height: 1;\n}\n\n.metricLabel {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--gray-700);\n}\n\n.metricInsight {\n  font-size: 0.75rem;\n  color: var(--gray-600);\n  line-height: 1.4;\n}\n\n/* Charts Grid */\n.chartsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 1.5rem;\n  padding: 1.5rem;\n}\n\n.chartContainer {\n  background: var(--white);\n}\n\n.chartLabel {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: 1rem;\n}\n\n.emptyChart {\n  padding: 2rem;\n  text-align: center;\n  color: var(--gray-500);\n  font-size: 0.85rem;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n}\n\n/* Bar Chart */\n.barChart {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.barGroup {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.barLabel {\n  font-size: 0.75rem;\n  color: var(--gray-600);\n  min-width: 80px;\n  font-weight: 500;\n}\n\n.barTrack {\n  flex: 1;\n  height: 24px;\n  background: var(--gray-100);\n  border-radius: 4px;\n  overflow: hidden;\n  min-width: 150px;\n}\n\n.bar {\n  height: 100%;\n  transition: width 0.3s ease;\n  border-radius: 4px;\n}\n\n.barValue {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  min-width: 30px;\n  text-align: right;\n}\n\n/* Role Chart */\n.roleChart {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.roleItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.roleHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.roleLabel {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--gray-700);\n}\n\n.roleCount {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--gray-900);\n}\n\n.roleBar {\n  height: 20px;\n  background: var(--gray-100);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.roleFill {\n  height: 100%;\n  transition: width 0.3s ease;\n}\n\n.rolePct {\n  font-size: 0.75rem;\n  color: var(--gray-600);\n  font-weight: 500;\n}\n\n/* Alerts */\n.alertsList {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.alert {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  border-radius: var(--radius);\n  border-left: 4px solid;\n  align-items: flex-start;\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.alertpositive {\n  background: #f0fdf4;\n  border-color: #22c55e;\n  color: #15803d;\n}\n\n.alertwarning {\n  background: #fefce8;\n  border-color: #eab308;\n  color: #854d0e;\n}\n\n.alertinfo {\n  background: #f0f9ff;\n  border-color: #0ea5e9;\n  color: #0369a1;\n}\n\n.alertIcon {\n  flex-shrink: 0;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.alertMessage {\n  flex: 1;\n}\n\n/* Insights & Recommendations */\n.insightBox {\n  padding: 1.5rem;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  border-left: 4px solid var(--green);\n  line-height: 1.6;\n  color: var(--gray-700);\n  font-size: 0.85rem;\n}\n\n.recommendationsList {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.recommendationItem {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  border-left: 4px solid var(--green);\n  align-items: flex-start;\n  font-size: 0.85rem;\n  line-height: 1.5;\n}\n\n.recNum {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: var(--green);\n  color: white;\n  border-radius: 50%;\n  font-size: 0.75rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.recText {\n  flex: 1;\n  color: var(--gray-700);\n}\n\n/* Skeleton Loaders */\n@keyframes shimmer {\n  0% { background-position: -1000px 0; }\n  100% { background-position: 1000px 0; }\n}\n\n.skeletonCard {\n  padding: 1.5rem;\n  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  height: 100px;\n}\n\n.skeletonText {\n  height: 16px;\n  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: 4px;\n}\n\n.skeletonBar {\n  height: 40px;\n  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: 4px;\n}\n\n.skeletonMetricCard {\n  padding: 1.5rem;\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n\n.skeletonAiSummary {\n  height: 100px;\n  background: linear-gradient(90deg, var(--gray-50) 0%, var(--gray-100) 50%, var(--gray-50) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: var(--radius);\n  border-left: 4px solid var(--green);\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 900px) {\n  .statsGrid { grid-template-columns: repeat(3, 1fr); }\n  .chartsGrid { grid-template-columns: 1fr; }\n}\n@media (max-width: 600px) {\n  .statsGrid { grid-template-columns: repeat(2, 1fr); }\n  .metricsGrid { grid-template-columns: 1fr; }\n  .chartsGrid { grid-template-columns: 1fr; }\n  .aiSummary { flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminDashboard_page__bBsHw`,
	"loading": `AdminDashboard_loading__c7kz6`,
	"pageHeader": `AdminDashboard_pageHeader__kUf8A`,
	"pageTitle": `AdminDashboard_pageTitle__1wNpT`,
	"pageSub": `AdminDashboard_pageSub__+X7l4`,
	"headerActions": `AdminDashboard_headerActions__jXD8v`,
	"actionBtn": `AdminDashboard_actionBtn__IpcR6`,
	"timePeriodSelect": `AdminDashboard_timePeriodSelect__P-IxV`,
	"statsGrid": `AdminDashboard_statsGrid__cavqM`,
	"statCard": `AdminDashboard_statCard__tS-sS`,
	"statValue": `AdminDashboard_statValue__rZ5CS`,
	"statLabel": `AdminDashboard_statLabel__My1GT`,
	"statSub": `AdminDashboard_statSub__PRdtu`,
	"section": `AdminDashboard_section__rcszr`,
	"sectionHeader": `AdminDashboard_sectionHeader__6IgCz`,
	"sectionTitle": `AdminDashboard_sectionTitle__zarjn`,
	"linkBtn": `AdminDashboard_linkBtn__uSzYi`,
	"empty": `AdminDashboard_empty__oUATu`,
	"tableWrap": `AdminDashboard_tableWrap__xUaGM`,
	"table": `AdminDashboard_table__-dmbJ`,
	"candidateCell": `AdminDashboard_candidateCell__qbV4Y`,
	"candidateAvatar": `AdminDashboard_candidateAvatar__xYTff`,
	"candidateName": `AdminDashboard_candidateName__TxN5g`,
	"candidateEmail": `AdminDashboard_candidateEmail__BaHOn`,
	"roleTag": `AdminDashboard_roleTag__I5lBJ`,
	"muted": `AdminDashboard_muted__+lLaX`,
	"pct": `AdminDashboard_pct__pYOzf`,
	"recoTag": `AdminDashboard_recoTag__QdbH8`,
	"tagGreen": `AdminDashboard_tagGreen__W5N2X`,
	"tagOrange": `AdminDashboard_tagOrange__E7Ar5`,
	"tagRed": `AdminDashboard_tagRed__12Hu1`,
	"viewBtn": `AdminDashboard_viewBtn__Z-hzj`,
	"aiSummary": `AdminDashboard_aiSummary__zAfe6`,
	"aiIcon": `AdminDashboard_aiIcon__fR+5A`,
	"aiLabel": `AdminDashboard_aiLabel__7pCgD`,
	"aiText": `AdminDashboard_aiText__HyJWc`,
	"aiLoadingText": `AdminDashboard_aiLoadingText__WIjhh`,
	"loadingSpinner": `AdminDashboard_loadingSpinner__zY7SO`,
	"spin": `AdminDashboard_spin__RuDpr`,
	"metricsGrid": `AdminDashboard_metricsGrid__pv7jV`,
	"metricCard": `AdminDashboard_metricCard__zUJ1A`,
	"metricValue": `AdminDashboard_metricValue__G216C`,
	"metricLabel": `AdminDashboard_metricLabel__e8kS3`,
	"metricInsight": `AdminDashboard_metricInsight__dirTS`,
	"chartsGrid": `AdminDashboard_chartsGrid__eCTdn`,
	"chartContainer": `AdminDashboard_chartContainer__Ru1CU`,
	"chartLabel": `AdminDashboard_chartLabel__hBZiR`,
	"emptyChart": `AdminDashboard_emptyChart__tOr2a`,
	"barChart": `AdminDashboard_barChart__DuQ6r`,
	"barGroup": `AdminDashboard_barGroup__fqfDA`,
	"barLabel": `AdminDashboard_barLabel__kzZ+f`,
	"barTrack": `AdminDashboard_barTrack__720ok`,
	"bar": `AdminDashboard_bar__lYxOm`,
	"barValue": `AdminDashboard_barValue__7AYGS`,
	"roleChart": `AdminDashboard_roleChart__px7C-`,
	"roleItem": `AdminDashboard_roleItem__xZg66`,
	"roleHeader": `AdminDashboard_roleHeader__ocaLC`,
	"roleLabel": `AdminDashboard_roleLabel__oV+FN`,
	"roleCount": `AdminDashboard_roleCount__BW9S8`,
	"roleBar": `AdminDashboard_roleBar__1Xtcp`,
	"roleFill": `AdminDashboard_roleFill__0llfF`,
	"rolePct": `AdminDashboard_rolePct__tzEu2`,
	"alertsList": `AdminDashboard_alertsList__pNumg`,
	"alert": `AdminDashboard_alert__5tZks`,
	"alertpositive": `AdminDashboard_alertpositive__b8t0r`,
	"alertwarning": `AdminDashboard_alertwarning__E-4he`,
	"alertinfo": `AdminDashboard_alertinfo__JWl5b`,
	"alertIcon": `AdminDashboard_alertIcon__cWz98`,
	"alertMessage": `AdminDashboard_alertMessage__JM5uz`,
	"insightBox": `AdminDashboard_insightBox__pOpB-`,
	"recommendationsList": `AdminDashboard_recommendationsList__Gvqns`,
	"recommendationItem": `AdminDashboard_recommendationItem__fHn4I`,
	"recNum": `AdminDashboard_recNum__px7gt`,
	"recText": `AdminDashboard_recText__9vut8`,
	"skeletonCard": `AdminDashboard_skeletonCard__c6rOu`,
	"shimmer": `AdminDashboard_shimmer__dfFL1`,
	"skeletonText": `AdminDashboard_skeletonText__7VKIE`,
	"skeletonBar": `AdminDashboard_skeletonBar__sQllP`,
	"skeletonMetricCard": `AdminDashboard_skeletonMetricCard__des4H`,
	"skeletonAiSummary": `AdminDashboard_skeletonAiSummary__tIMKS`
};
export default ___CSS_LOADER_EXPORT___;
